/* RegisterTile — one register at a glance, in the shell's language (13-15).
 * The headline count is the mock's serif numeral (.pagehead .side b: charcoal, tabular); the
 * register name is plain sentence case, not a tracked capital label. Purple stays identity only:
 * it appears on hover and focus, never as a fill. Overdue is the gentle amber (D-13-02-1), so the
 * tile's overdue chip is re-toned from the Badge's red here, in CSS, without touching the TSX. */

.tile {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.tile:hover {
  border-color: var(--purple-light);
}

.tile:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

/* ── Header: register name ── */
.head {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* The old identity dot: the name carries the tile now. */
.dot {
  display: none;
}

.name {
  font-size: 15px;
  font-weight: 600;
  color: var(--charcoal);
}

/* ── Headline count ── */
.headline {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 2px;
}

.count {
  font-family: var(--serif);
  font-weight: 400;
  font-size: 44px;
  line-height: 1;
  letter-spacing: -0.01em;
  color: var(--charcoal);
  font-variant-numeric: tabular-nums;
}

.unit {
  font-size: 13.5px;
  color: var(--gray);
}

.blurb {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--gray);
}

/* ── Secondary cuts: open + overdue ── */
.cuts {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.cut {
  font-size: 13.5px;
  color: var(--charcoal);
}

.cutNum {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.cutMuted {
  font-size: 12.8px;
  color: var(--gray);
}

.overdueChip {
  display: inline-flex;
}

/* Overdue is amber, never red (D-13-02-1). */
.overdueChip > * {
  background-color: var(--amber-soft);
  color: var(--amber);
}

/* ── Extra row (SIRS chip / risk rating strip) ── */
.extraRow {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ratingStrip {
  display: inline-flex;
  gap: 4px;
  flex-wrap: wrap;
}
